import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject; /* @jsx jsx */
import { jsx, css } from '../../util/emotionReact';
import theme from '../../util/theme';
import Default from './default';
var Article = function Article(props) { return jsx(Default, _extends({ css: css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      padding-top: 1rem;\n      max-width: ", ";\n      margin: 0 auto;\n    "])), theme.breakpoints.value("article")) }, props)); };
export default Article;
